import axios from 'axios'
import { MdUtils, Tips } from '@/utils'
import './config'

class BaseApis {
  request(url, data, showTips = false, showErrorTips = true) {
    showTips && Tips.loading()
    let userId = MdUtils.getUserInfo('Id') || 0

    if (url.indexOf('http') < 0) {
      url = '/Api/' + url
    }
    return axios({
      method: 'post',
      url: url,
      data: {
        ...data,
        Header: {
          Channel: "CMS-MOBILE",
          Operator: userId
        }
      }
    })
      .then(res => {
        showTips && Tips.clear()
        return res.Body
      })
      .catch((err) => {
        showErrorTips && Tips.toast(err.message)
        return Promise.reject(err)
      })
  }
}


export default new BaseApis()
